import httpUrl from './baseUrl'
import axios from 'axios'
//import Vue from './../../main.js';
//import qs from 'qs'
//import { Message } from 'element-ui';
// 拦截request,设置全局请求为ajax请求
axios.interceptors.request.use(config => {
//if(config.method=='get' && config.url=="http://jisukdcx.market.alicloudapi.com/express/query"){
//  config.headers.Authorization='APPCODE d12845863ae04229ab7eaef07f75de77'
//  //config.headers.Authorization='APPCODE bf090285f241489b9afccdd18c707b18'
//}
  return config;
}, error => {
  return Promise.reject(error)
})
// 拦截响应response，并做一些错误处理
axios.interceptors.response.use(response => {
  if(response.data.status){
}else{
  if(response.data.success==false && response.data.state==2){
//  Message({
//    title:'提示',
//    message:response.data.msg,
//    type:'error',
//    onClose:()=>{
//	       Vue.$router.push('/')
//	  	}
//  })
  }
  if(response.data.success==false && response.data.state!=2){
//  Message({
//    title:'提示',
//    message:response.data.msg,
//    type:'error'
//  })
  }
}

  return response
}, error => {
  if(error.config.url=="https://api.bats-bio.com/ajax/"){
    // Message({
    //   title:'提示',
    //   message:error.response.data.msg,
    //   showClose:true,
    //   type:'error'
    // })
  }else{
//  Message({
//    title:'提示',
//    message:'请求失败,请重新尝试',
//    showClose:true,
//    type:'error'
//  })
  }
  return Promise.resolve(error.response)
})
export default {

  post (url, data) {
    
  return axios({
      method: 'post',
      baseURL: httpUrl,
      url,
      data: JSON.stringify(data),
      //timeout: 10000,
      headers: {
//    	 'Access-Control-Allow-Origin': '*', 
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      }
    }).then(
      (response) => {
      //return checkStatus(response)
      return response.data;
    }
)
},
post_token (url, data) {
    let req_data = {
      token:'96e5f099c35734a1a334b03b9e786bd6'
    }
    for(let p in data){
      req_data[p] = data[p];
    }
    
  return axios({
      method: 'post',
      baseURL:httpUrl,
      url,
      data: JSON.stringify(req_data),
      //timeout: 10000,
      headers: {
//       'Access-Control-Allow-Origin': '*', 
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin':'*'
      }
    }).then(
      (response) => {
      //return checkStatus(response)
      return response.data;
    }
)
},
get (url, params) {
  return axios({
      method: 'get',
      baseURL: httpUrl,
      url,
      params, // get 请求时带的参数
      //timeout: 10000,
      headers: {
//    	 'Access-Control-Allow-Origin': '*', 
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
      //return checkStatus(response)
      return response.data;
    }
)
}
}



// WEBPACK FOOTER //
// ./src/components/http/http.js